module.exports = __webpack_public_path__ + "static/img/logo_kakaopay.55ec592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/logo_kakaopay.png
// module id = dsES
// module chunks = 10